import type { Observable } from 'rxjs';
import type { Domain } from '@common/types/domain.type';
import type { FormAdditionalSettingsFormGroupType } from '@components/sp-form-additional-settings';

import { ChangeDetectionStrategy, Component, computed, inject, Input, type OnInit } from '@angular/core';
import { WebBaseControlTypedSettingsComponent } from '@web/widgets/common/abstract/web-base-control-typed-settings.component';

import { environment } from '@web-env/environment';
import { LayoutFacade } from '@web/store/layout/layout.facade';
import { PagesFacade } from '@web/store/website/pages/pages.facade';
import { DomainsFacade } from '@web/store/website/domains/domains.facade';
import { type SitePage } from '@common/types/site-page.type';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { SpFormAdditionalSettingsModule } from '@components/sp-form-additional-settings/src/sp-form-additional-settings.module';
import { WebSettingsModule } from '@web/shared/components/web-settings/web-settings.module';
import { injectPromoCodesQuery, type PromoCode } from '@integrations/promo-codes';

@Component({
    selector: 'web-shop-cart-form-additional-settings',
    templateUrl: './shop-cart-form-additional-settings.component.html',
    styleUrls: ['./shop-cart-form-additional-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [WebSettingsModule, SpFormAdditionalSettingsModule, AsyncPipe, TranslateModule],
})
export class ShopCartFormAdditionalSettingsComponent
    extends WebBaseControlTypedSettingsComponent<FormAdditionalSettingsFormGroupType>
    implements OnInit
{
    @Input() public isHasSuccessPageOption: boolean;

    private readonly pagesFacade: PagesFacade = inject(PagesFacade);
    private readonly domainsFacade: DomainsFacade = inject(DomainsFacade);
    private readonly layoutFacade: LayoutFacade = inject(LayoutFacade);
    private readonly promoCodesQuery = injectPromoCodesQuery();

    public readonly websitePages$: Observable<SitePage[]> = this.pagesFacade.pages$;
    public readonly websiteDomains$: Observable<Domain[]> = this.domainsFacade.domains$;
    public readonly promoCodes = computed<PromoCode[]>(() => this.promoCodesQuery.data() ?? []);

    public readonly baseHref = environment.baseHref;
    public readonly selectedDeviceMode$ = this.layoutFacade.deviceMode$;

    ngOnInit(): void {
        super.ngOnInit();
    }
}
